import { useContext, useEffect } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { ConfigContext } from "../../contexts/ConfigContext";
import { ProcessContext } from "../../contexts/ProcessContext";
import { RegistryMapper } from "../mappers/RegistryMapper";
import { useLanguages } from "./useLanguages";

export const useAppConfiguration = () => {
  const {
    state: { agent },
    dispatch: authDispatch,
  } = useContext(AuthContext);
  const {
    state: { participant },
    dispatch,
  } = useContext(ProcessContext);
  const { dispatch: configDispatch } = useContext(ConfigContext);
  const { setLanguage } = useLanguages();

  useEffect(() => {
    if (agent) {
      setRegistry();
      setLanguage();
      setFlowLoading(false);
    }
  }, [agent]);

  const requestGetLoanAndAgent = (loanId) => {
    authDispatch({
      type: "REQUEST_GET_LOAN_BEFORE_AGENT_SEQUENCE",
      payload: loanId,
    });
  };

  const setRegistry = () => {
    configDispatch({
      type: "SET_REGISTRY",
      payload: {
        registry: RegistryMapper.hydrate(agent.custom_registry),
        fulfilledBy: participant.onboardingDetails?.fulfilled_by,
      },
    });
  };

  const setFlowLoading = (show) =>
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show },
    });

  return { requestGetLoanAndAgent };
};
